module.exports = __webpack_public_path__ + "img/redchirp-logo-on-dark-grey.5d5c2089.png";